import { billingContract } from "@salon/api-contracts";
import { initTsrReactQuery } from "@ts-rest/react-query/v5";
import { env } from "@/lib/env";
import { useAuthStore } from "@/lib/store/auth-enhanced";

export const billingApi = initTsrReactQuery(billingContract, {
  baseUrl: env.apiUrl,
  baseHeaders: {
    authorization: () => {
      const token = useAuthStore.getState().accessToken;
      return token ? `Bearer ${token}` : "";
    },
  },
});
